// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Nr81","containerItemsCenter":"Skeleton_containerItemsCenter__5P-lL"};